var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


var BASE_URL = '/prototype/accounting/accounts-receivable/transactions';

export default {
    props: ['inapplicant'],
    data: function data() {
        return {
            applicant: this.inapplicant,
            period: moment(),
            transaction_date: moment().format("MM/DD/YYYY"),
            amount: '',
            transaction_file_bool: false,
            lines: [{
                balance: 0.00,
                reference: '',
                amount: 0.00,
                hasFile: false
            }],
            paymentTypes: [],
            saving: false
        };
    },

    watch: {
        inapplicant: function inapplicant(newData, oldData) {

            this.applicant = newData;

            this.lines[0].applicant = newData.id;

            this.loadApplicant();
        }
    },
    mounted: function mounted() {

        this.loadPaymentTypes();
        this.loadApplicant();
    },
    created: function created() {

        Event.$on('load-applicant-payment-balance', this.loadApplicant);
    },
    beforeDestroy: function beforeDestroy() {

        Event.$off('load-applicant-payment-balance');
    },

    methods: {
        loadPaymentTypes: function loadPaymentTypes() {
            var _this = this;

            var self = this;

            axios.get('/api/paymentTypes').then(function (response) {
                _this.paymentTypes = response.data;
            });
        },
        loadApplicant: function loadApplicant() {

            var self = this;

            if (this.applicant && this.applicant.id) {

                axios.post('/prototype/accounting/accounts-receivable/applicant/balance', {
                    id: this.inapplicant.id
                }).then(function (resp) {
                    console.log('resp.data', resp.data);
                    self.lines = [{
                        balance: resp.data,
                        reference: '',
                        amount: 0.00,
                        payment_type: self.paymentTypes[0],
                        hasFile: false
                    }];
                });
            }
        },
        save: function save() {
            var _this2 = this;

            var $el = this;

            this.saving = true;

            var formData = new FormData(document.querySelector('form'));

            var applicant = _extends({}, this.applicant);
            delete applicant.person['trans_union'];
            var deposit = {
                applicant: applicant,
                period: this.period,
                transaction_date: this.transaction_date,
                amount: this.amount,
                transaction_file_bool: this.transaction_file_bool,
                lines: this.lines,
                paymentTypes: this.paymentTypes
            };

            deposit['total'] = this.total;

            deposit['residents'] = '';

            formData.append("deposit", JSON.stringify(deposit));

            formData.append('applicant_id', this.applicant.id);

            axios.post('/prototype/accounting/accounts-receivable/deposits/store-applicant', formData).then(function () {

                $el.saving = false;

                _this2.$snotify.success('Payment has been recorded.');

                $el.loadApplicant();

                Event.$emit('refresh-applicant-ledger', $el.applicant);

                Event.$emit('mark-application-paid');
            });
        }
    },
    computed: {
        total: function total() {
            return Number.parseFloat(this.lines.reduce(function (prev, cur) {
                return prev + cur.amount;
            }, 0)).toFixed(2);
        },
        applicantFullName: function applicantFullName() {

            if (!this.applicant || !this.applicant.person) {
                return '';
            }

            return this.applicant.person.first_name + ' ' + this.applicant.person.last_name;
        }
    }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/babel-loader/lib?{"cacheDirectory":true,"presets":[["env",{"modules":false,"targets":{"browsers":["> 2%"],"uglify":true}}]],"plugins":["transform-object-rest-spread",["transform-runtime",{"polyfill":false,"helpers":false}]],"env":{"test":{"presets":[["env",{"targets":{"node":"current"}}]]},"development":{"presets":[["env",{"modules":false}]]},"production":{"presets":[["env",{"modules":false,"targets":{"browsers":"> 2%","uglify":true}}]]}}}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./resources/assets/js/components/person/applicants/ApplicantPayment.vue
// module id = magK
// module chunks = 0 1